import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import NokiaFontRegular from '@nokia-csf-uxr/ccfk-assets/fonts/NokiaPureText-Regular.woff';
import NokiaFontBold from '@nokia-csf-uxr/ccfk-assets/fonts/NokiaPureText-Bold.woff';
import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);

/**
 * Generation of the PDF for a dual band link
 */

/**
 * Register Nokia fonts
 */
Font.register({
  family: 'NokiaFont',
  fonts: [
    {
      src: NokiaFontRegular,
    },
    {
      src: NokiaFontBold,
      fontWeight: 'bold',
    }
  ],
});


/**PDF
 * CSS styles to lay out the 
 */
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column'
  },
  logo: {
    width: 150,
    marginLeft: "3vw"
  },
  section: {
    width: '100%',
    padding: 5
  },
  titlePDF: {
    position: "absolute",
    width: "200px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -15%)", 
    textAlign: "center",
    fontFamily: "NokiaFont",
    fontWeight: "bold",
    fontSize: "10px"
  },
  date: {
    position: "absolute",
    right: "8%",
    top: "30%",
    textAlign: "right",
    fontFamily: "NokiaFont",
    fontSize: "8px"
  },
  rowSection: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 7,
    marginTop: "5vh"
  }
});

/**
 * Style for table which contains technical information like equipment type, frequency....
 */
const TECHNICAL_BAND_INFO_STYLE = StyleSheet.create({
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderRightWidth: 0, 
    borderBottomWidth: 0 
  },
  tableCenter: {
    display: "table", 
    width: "auto",
    margin: "0 auto",
    borderStyle: "solid", 
    borderWidth: 1, 
    borderRightWidth: 0, 
    borderBottomWidth: 0 
  },
  tableRow: {
    flexDirection: "row" 
  }, 
  tableCol: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 ,
  },
  tableCol50: { 
    width: "50%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 ,
  }, 
  tableColBandInfo: { 
    width: "calc(100% / 3)", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 ,
  }, 
  tableColBandHeader: {
    width: "15%", 
    borderStyle: "solid", 
    borderTop: "0 !important",
    borderRight: "0 !important",
    borderLeft: "0 !important",
    borderBottom: "1 solid !important"
  },
  tableCell: { 
    margin: "auto", 
    marginTop: 5,
    marginBottom: 5
  },
  columnName: { 
    margin: "auto", 
    marginTop: 5,
    marginBottom: 5,
    fontFamily: "NokiaFont",
    fontWeight: "bold"
  }
});

/**
 * Display band information
 * @param props
 * data : javascript object {firstBand: {}, secondBand: {}}
 * @returns 
 */
const LinkEquipmentDetailsByBand = (props) => {
  let firstBand = props.data?.firstBand.data.form
  let secondBand = props.data?.secondBand.data.form
  console.log(props.data)

  return <>
  <View style={{...TECHNICAL_BAND_INFO_STYLE.tableCenter, width: "50%"}}>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={{...TECHNICAL_BAND_INFO_STYLE.tableColBandInfo, "width": "50% !important"}}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Band 1</Text> 
        </View> 
        <View style={{...TECHNICAL_BAND_INFO_STYLE.tableColBandInfo, "width": "50% !important"}}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Band 2</Text> 
        </View> 
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{props.data?.firstBand.link.type}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Equipment</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{props.data?.firstBand.link.type}</Text> 
        </View> 
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.frequencyBand == 6.2 ? 6 : firstBand.edObj.frequencyBand} GHz</Text> 
        </View>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Frequency</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.frequencyBand == 6.2 ? 6 : secondBand.edObj.frequencyBand} GHz</Text> 
        </View> 
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}>
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.channelBandwidth} MHz</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Channel bandwidth</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}>
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.channelBandwidth} MHz</Text> 
        </View> 
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.linkConfiguration.match(/[0-9]\+[0-9]/)[0]}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Configuration</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.linkConfiguration.match(/[0-9]\+[0-9]/)[0]}</Text> 
        </View> 
      </View>

      {(firstBand.edObj.linkConfiguration.includes("1+1") || firstBand.edObj.linkConfiguration.includes("2+2") || firstBand.edObj.linkConfiguration.includes("4+4"))
      || (secondBand.edObj.linkConfiguration.includes("1+1") || secondBand.edObj.linkConfiguration.includes("2+2") || secondBand.edObj.linkConfiguration.includes("4+4")) ? 
      <>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
          <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
            <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.linkConfiguration.includes("SD") ? "ON" : "OFF"}</Text> 
          </View> 
          <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}>
            <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Space diversity</Text> 
          </View> 
          <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
            <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.linkConfiguration.includes("SD") ? "ON" : "OFF"}</Text> 
          </View> 
        </View>
      </>
      :
      <></>
      }

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.linkConfiguration.includes("AP") ? "Alternate polar" : "Copolar"}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Polarization</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.linkConfiguration.includes("AP") ? "Alternate polar" : "Copolar"}</Text> 
        </View> 
      </View>

      {(firstBand.edObj.linkConfiguration.includes("AP") || secondBand.edObj.linkConfiguration.includes("AP")) ?
      <>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.linkConfiguration.includes("XPIC") ? "ON" : "OFF"}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>XPIC</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.linkConfiguration.includes("XPIC") ? "ON" : "OFF"}</Text> 
        </View> 
      </View>
      </>
      : <></> }

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.linkPolarization == "H" ? "Horizontal" : "Vertical"}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Orientation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.linkPolarization == "H" ? "Horizontal" : "Vertical"}</Text> 
        </View> 
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.adaptiveModulation ? "ON" : "OFF"}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Adaptative modulation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.adaptiveModulation ? "ON" : "OFF"}</Text> 
        </View> 
      </View>

    {(firstBand.edObj.adaptiveModulation || secondBand.edObj.adaptiveModulation) ? 
    <>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.minModulation}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Minimum modulation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.minModulation}</Text> 
        </View> 
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.maxModulation}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Maximum modulation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.maxModulation}</Text> 
        </View> 
      </View>
    </>
    : 
    <>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.minModulation}</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Modulation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.minModulation}</Text> 
        </View> 
      </View>
    </>
    }

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.edObj.txPowers[0]} dBm</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>TX Power</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.edObj.txPowers[0]} dBm</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.adObj.site1AntennaMain}</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>{firstBand.edObj.linkConfiguration.includes("SD") ? "Site 1 main antenna" : "Site 1 antenna"}</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.adObj.site1AntennaMain}</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{firstBand.adObj.site2AntennaMain}</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>{firstBand.edObj.linkConfiguration.includes("SD") ? "Site 2 main antenna" : "Site 2 antenna"}</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandInfo}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{secondBand.adObj.site2AntennaMain}</Text> 
      </View> 
    </View>
  </View>
  </>
}

/**
 * Generate a table which contains common information like path length
 * @param {*} props
 * - band : one of the link's bands 
 * @returns 
 */
const CommonLinkInformation = (props) => {
  let band = props.band?.data.form
  let isAdvancedLink = (band.pdObj.site1LatitudeValue != null)
  return <>
  <View style={{...TECHNICAL_BAND_INFO_STYLE.tableCenter, width: "50%"}}>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={{...TECHNICAL_BAND_INFO_STYLE.tableColBandInfo, "width": "50% !important"}}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Link Budget Details</Text> 
      </View> 
      <View style={{...TECHNICAL_BAND_INFO_STYLE.tableColBandInfo, "width": "50% !important"}}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>User's inputs</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Link's name</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{props.band?.link.name}</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 1</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.pdObj.site1Name}</Text> 
      </View> 
    </View>
      
    { isAdvancedLink ?
    <>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 1 longitude</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.pdObj.site1LongitudeValue} {band.pdObj.site1LongitudeDirection}</Text> 
        </View> 
      </View>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 1 latitude</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.pdObj.site1LatitudeValue} {band.pdObj.site1LatitudeDirection}</Text> 
        </View> 
      </View>
    </>
    : <></> }

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 2</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.pdObj.site2Name}</Text> 
      </View> 
    </View>
  
    { isAdvancedLink ?
    <>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 2 longitude</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.pdObj.site2LongitudeValue} {band.pdObj.site2LongitudeDirection}</Text> 
        </View> 
      </View>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 2 latitude</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.pdObj.site2LatitudeValue} {band.pdObj.site2LatitudeDirection}</Text> 
        </View> 
      </View>
    </>
    : <></> }
  
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Path length</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{props?.edited_miles ? (band.pdObj.pathLength/1.609).toFixed(2) : band.pdObj.pathLength} {props?.edited_miles ? "miles" : band.pdObj.distanceUnit}</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Standard</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.edObj.equipmentStandard}</Text> 
      </View> 
    </View>
  </View>

  <View style={{...TECHNICAL_BAND_INFO_STYLE.tableCenter, width: "50%"}}>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={{...TECHNICAL_BAND_INFO_STYLE.tableColBandInfo, "width": "50% !important"}}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Link Budget Details</Text> 
      </View> 
      <View style={{...TECHNICAL_BAND_INFO_STYLE.tableColBandInfo, "width": "50% !important"}}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>User values</Text> 
      </View> 
    </View>
  
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Propagation methodology</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.multipathOutageStandard}</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Propagation condition</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.propagationCondition}</Text> 
      </View> 
    </View>

    { isAdvancedLink ?
    <>
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Fade factor</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ Number.parseFloat( band.coObj?.fadeOccurenceFactorAuto).toExponential(10) }</Text> 
      </View> 
    </View>
    </>
    : <></> }

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Rain outage prediction</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.rainOutageStandard}</Text> 
      </View> 
    </View>

    {band.coObj.rainOutageStandard == "ITU.R P530" ?
    <>
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Rain rate</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{isAdvancedLink ? band.coObj.manualRainRate : band.coObj.rainRate} mm/hr</Text> 
      </View> 
    </View>
    </>
    : <></> }

    {band.coObj.rainOutageStandard == "ITU.R P530" && isAdvancedLink ? 
    <>
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Rain rate standard</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.rainOutageMethod}</Text> 
      </View> 
    </View>
    </>
    : <></>}

    {band.coObj.rainOutageStandard == "ITU.R P530" ?
    <></>
    :
    <>
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Crane zone</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.craneZone}</Text> 
      </View> 
    </View>
    </>
    }

    {isAdvancedLink ?
    <>
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Annual outage methodology</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.annualOutageMethod}</Text> 
      </View> 
    </View>
    </>
    : <></>}

    {isAdvancedLink && band.coObj.annualOutageMethod != "itu" ?
    <>
    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Average temperature</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.avgTempValue} {band.coObj.avgTempUnit}</Text> 
      </View> 
    </View>
    </>
    : <></> }

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Field margin</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.coObj.calculationMargin} dB</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 1 additional line loss</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.clObj.site1LineMain} dB</Text> 
      </View> 
    </View>

    <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>Site 2 additional line loss</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol50}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{band.clObj.site2LineMain} dB</Text> 
      </View> 
    </View>
  </View>
  </>
}

/**
 * Generate data grid which contains calculated information
 * @param {*} props 
 * @returns 
 */
const LinkPerformanceTable = (props) => {
  let firstBand = props.data?.firstBand?.data
  let secondBand = props.data?.secondBand?.data

  let lines = []
  let totalLines = (firstBand.modulations.length+secondBand.modulations.length)

  for (let i = 0; i < totalLines; i++) {  // Loop on modulations because I can't use a for loop in render (I use only i to get data for a specific modulation)
    if(firstBand.modulations[i] == null && secondBand.modulations[i] == null) {
      break;
    }
    
    let line = [];
    if(firstBand.modulations[i] != null) {
      line.push(<><View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ firstBand.modulations[i] }</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ firstBand.fadeMargins[i].toFixed(2) }</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ firstBand.capacities[i].toFixed(1) }</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}>
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ firstBand.availabilities[i] > 0 && firstBand.availabilities[i] < 100 ? firstBand.availabilities[i].toFixed(7) : "OUT of RANGE" }</Text> 
      </View></>);

    } else {
      line.push(<><View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
      <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}>
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View></>)
    }

    if(secondBand.modulations[i] != null) {
      line.push(<><View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ secondBand.modulations[i] }</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ secondBand.fadeMargins[i].toFixed(2) }</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ secondBand.capacities[i].toFixed(1) }</Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}>
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}>{ secondBand.availabilities[i] > 0 && secondBand.availabilities[i] < 100 ? secondBand.availabilities[i].toFixed(7) : "OUT of RANGE" }</Text> 
      </View></>)
    } else {
      line.push(<><View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
      <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View> 
      <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}>
        <Text style={TECHNICAL_BAND_INFO_STYLE.tableCell}></Text> 
      </View></>)
    }

    lines.push(<View style={TECHNICAL_BAND_INFO_STYLE.tableRow}>{line}</View>)
  }

  return <>
    <View style={TECHNICAL_BAND_INFO_STYLE.table}>
      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandHeader}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Band 1</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandHeader}></View>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandHeader}></View>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}></View>

        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandHeader}>
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Band 2</Text>
        </View>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandHeader}></View>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableColBandHeader}></View>
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}></View>
      </View>

      <View style={TECHNICAL_BAND_INFO_STYLE.tableRow}> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Modulation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Fade Margin [dB]</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Capacity [Mbps]</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Total Availability [%]</Text> 
        </View>

        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Modulation</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Fade Margin [dB]</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Capacity [Mbps]</Text> 
        </View> 
        <View style={TECHNICAL_BAND_INFO_STYLE.tableCol}> 
          <Text style={TECHNICAL_BAND_INFO_STYLE.columnName}>Total Availability [%]</Text> 
        </View>
      </View>
      
      { lines }
      
    </View>
  </>
}
  
const getDate = () => {
  let date = new Date();
  return date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear();
}

// Create Document Component
const DualBandBudgetPDF = (props) => (
  <Document title={props?.link?.link?.name}>
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.rowSection}>
        <Image source="/assets/logo/nokia_logo.png" style={styles.logo}></Image>
        <View style={styles.titlePDF}>
          <Text>DUAL BAND LINK BUDGET</Text>
          <Text>{props?.link?.firstBand?.data?.form.pdObj.site1Name} - {props?.link?.firstBand?.data?.form.pdObj.site2Name}</Text>
        </View>
        <View style={styles.date}>
          <Text>{ getDate() }</Text>
        </View>
      </View>
      <View style={styles.section}>
        <View style={styles.rowSection}>
          <LinkEquipmentDetailsByBand data={props?.link} />
          <LinkPerformanceTable data={props?.link} />
        </View>

        <View style={{...styles.rowSection, marginTop: "1vh"}}>
          <CommonLinkInformation band={props.link.firstBand} />
        </View>
      </View>
    </Page>
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.rowSection}>
        <Image source="/assets/logo/nokia_logo.png" style={styles.logo}></Image>
        <View style={styles.titlePDF}>
          <Text>DUAL BAND LINK BUDGET</Text>
          <Text>{props?.link?.firstBand?.data?.form.pdObj.site1Name} - {props?.link?.firstBand?.data?.form.pdObj.site2Name}</Text>
        </View>
        <View style={styles.date}>
          <Text>{ getDate() }</Text>
        </View>
      </View>
      <View style={styles.section}>

        <View style={styles.rowSection}>
          <Image src={`${props.chart}`} />
        </View>

      </View>
    </Page>
  </Document>
)

export default DualBandBudgetPDF;